import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, Stack, Typography } from '@mui/material';

interface IPriceGroupLegalNotesProps {
	conditionsUrl?: string;
	legalText?: string;
}

export const PriceGroupLegalNotes: FC<IPriceGroupLegalNotesProps> = ({
	conditionsUrl,
	legalText,
}) => {
	const { t } = useTranslation('ticketshop');

	const legalTextParts = legalText?.split('\\n').filter(Boolean) ?? [];

	return (
		<Stack gap={1} data-testid="price-group-legal-notes">
			{legalTextParts.map((part, index) => (
				<Typography
					key={index}
					variant="l1"
					color="solutions.600"
					component="p"
				>
					{part}
					{index === legalTextParts.length - 1 && conditionsUrl && (
						<>
							{' '}
							<Link
								href={conditionsUrl}
								target="_blank"
								rel="noopener noreferrer"
								underline="always"
								sx={{
									color: (theme) => theme.palette.primary.main,
									typography: 'l1',
								}}
							>
								{t('operator_tickets.legal_more_info')}
							</Link>
						</>
					)}
				</Typography>
			))}

			{legalTextParts.length === 0 && conditionsUrl && (
				<Typography variant="l1" color="solutions.600" component="p">
					<Link
						href={conditionsUrl}
						target="_blank"
						rel="noopener noreferrer"
						underline="always"
						sx={{
							color: (theme) => theme.palette.primary.main,
							typography: 'l1',
						}}
					>
						{t('operator_tickets.legal_more_info')}
					</Link>
				</Typography>
			)}
		</Stack>
	);
};
